import { ComponentProjectListPageState } from ".";
import { Option } from "../../util/option";

export const displayColumn = [
  {
    label: "STG/PRD Deployment Plan Date",
    value: "stgDplymntPlnDate,prdDplymntPlnDate",
  },
  {
    label: "STG Deployment Plan Date",
    value: "stgDplymntPlnDate",
  },
  {
    label: "Component Project Status",
    value: "pjtSts",
  },
  {
    label: "STG IF Can Deployment",
    value: "stgIfdDplymntPsblFlg",
  },
  {
    label: "PRD IF Can Deployment",
    value: "prdIfdDplymntPsblFlg",
  },
];

export const ComponentProjectListPageInitialState: ComponentProjectListPageState =
  {
    dipByRegion: "",
    rootComponentId: "",
    componentId: "",
    pjtStsList: [],
    projectName: "",
    cpntPjtList: [],
    generalCode: {
      inDefCommonFlagType: [] as Option[],
      tcktStsTypeCpntPrjPrgrs: [] as Option[],
    },
    isEdited: false,
    fieldPath: {
      dipByRgn: "dipByRgn",
      rootCpntId: "rootCpntId",
      cpntId: "cpntId",
      pjtSts: "pjtSts",
    },
    displayColumn: displayColumn,
  };
